<section class="app-download ptb-100">
    <div class="container">
        <div class="app-download-content">
            <h3>{{'main_title_download' | translate}}</h3>
            <div class="bar"></div>
            <p>{{'sub_title_download' | translate}}</p>
            <div class="app-holder">
                <a routerLink="/"><img src="assets/img/store/1.png" alt="image"></a>
                <a routerLink="/"><img src="assets/img/store/2.png" alt="image"></a>
            </div>
        </div>
    </div>
</section>
